import { createAsyncThunk } from '@reduxjs/toolkit';

import { getModelSettings, getDropDownLists, getEnumLists, getPortfolioAllocationTypes, getCountriesList, getInstrumentModelSettings, generateNSM, getSymbolStatus, postValidateModel, getListingExchanges, getSymbols, getCusipStatus, getIsinStatus, getMarketCloseDays, getMarketCloseDaysCustom, deleteMarketCloseDayCustom, postMarketCloseDayCustom } from './cruds';


export const ACTION_TYPE_PARENT = 'utilities'

// NOTE: keep function name and thunk child name same
export const fetchModelSettings = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchModelSettings`,
  async (modelType: string, { rejectWithValue }) => {
    try {
      const response = await getModelSettings(modelType)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const clearModelSettings = createAsyncThunk(`${ACTION_TYPE_PARENT}/clearModelSettings`,
  async () => {
    return [];
  }
)

export const fetchDropDownList = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDropDownList`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDropDownLists()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const fetchEnumList = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchEnumList`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getEnumLists()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const fetchPortfolioAllocationTypes = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchPortfolioAllocationTypes`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPortfolioAllocationTypes()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchListingExchanges = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchListingExchanges`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getListingExchanges()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchCountriesList = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchCountriesList`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCountriesList()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchInstrumentModelSchema = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchInstrumentModelSchema`,
  async (modelType: string, { rejectWithValue }) => {
    try {
      const response = await getInstrumentModelSettings(modelType)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// * get instument history model schema
export const fetchInstrumentHistoryModelSchema = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchInstrumentHistoryModelSchema`,
  async (modelType: string, { rejectWithValue }) => {
    try {
      const response = await getModelSettings(modelType)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

//* generates a fresh NSM to be used with instrument stage
export const generateUnusedNSM = createAsyncThunk(`${ACTION_TYPE_PARENT}/generateUnusedNSM`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await generateNSM()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

//* fetch the status of the symbol
export const fetchSymbolStatus = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchSymbolStatus`,
  async ({symbol, nsm} : any, { rejectWithValue }) => {
    try {
      const response = await getSymbolStatus(symbol, nsm)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

//* validate a field for a certain property based on the model
export const validateModelOnBackend = createAsyncThunk(`${ACTION_TYPE_PARENT}/validateModelOnBackend`,
  async ({modelName, propertyName, payload} : any, { rejectWithValue }) => {
    try {
      const response = await postValidateModel(modelName, propertyName, payload)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

//* get symbols for symbol generator
export const fetchSymbols = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchSymbols`,
  async ({requestHeaders = undefined, ...payload} : any, { rejectWithValue }) => {
    try {
      const response = await getSymbols(payload, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response.data })
    }
  }
)

//* fetch the status of CUSIP
export const fetchCusipStatus = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchCusipStatus`,
  async ({cusip, nsm} : any, { rejectWithValue }) => {
    try {
      const response = await getCusipStatus(cusip, nsm)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

//* fetch the status of ISIN
export const fetchIsinStatus = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchIsinStatus`,
  async ({isin, nsm} : any, { rejectWithValue }) => {
    try {
      const response = await getIsinStatus(isin, nsm)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)

//* fetch market close days - US Nasdaq holidays
export const fetchMarketCloseDays = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchMarketCloseDays`,
  async ({params, requestHeaders = undefined} : any, { rejectWithValue }) => {
    try {
      const response = await getMarketCloseDays(params, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response.data })
    }
  }
)

//* fetch market close days - Custom holidays
export const fetchMarketCloseDaysCustom = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchMarketCloseDaysCustom`,
  async ({params, requestHeaders = undefined} : any, { rejectWithValue }) => {
    try {
      const response = await getMarketCloseDaysCustom(params, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response.data })
    }
  }
)

//* delete market close day - Custom holidays
export const removeMarketCloseDay = createAsyncThunk(`${ACTION_TYPE_PARENT}/removeMarketCloseDay`,
  async ({params, requestHeaders = undefined} : any, { rejectWithValue }) => {
    try {
      const response = await deleteMarketCloseDayCustom(params, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response.data?.title ?? err.response.data, errors : err.response.data?.errors })
    }
  }
)

//* post market close day - Custom holidays
export const addMarketCloseDay = createAsyncThunk(`${ACTION_TYPE_PARENT}/addMarketCloseDay`,
  async ({params, requestHeaders = undefined} : any, { rejectWithValue }) => {
    try {
      const response = await postMarketCloseDayCustom(params, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? '' })
    }
  }
)